import React from 'react'

const SvgSunFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M12 2a1 1 0 00-1 1v3.083a6.04 6.04 0 012 0V3a1 1 0 00-1-1zM6.121 4.707l2.403 2.402a6.034 6.034 0 00-1.415 1.414L4.707 6.121a1 1 0 111.414-1.414zM3 11h3.083a6.04 6.04 0 000 2H3a1 1 0 110-2zM4.706 18.122l2.506-2.506c.404.535.896 1 1.455 1.374L6.12 19.536a1 1 0 01-1.415-1.414zM11 21v-3.083a6.036 6.036 0 002 0V21a1 1 0 11-2 0zM18.121 19.535l-2.644-2.644a6.034 6.034 0 001.414-1.415l2.645 2.645a1 1 0 11-1.415 1.414zM21 13h-3.083a6.036 6.036 0 000-2H21a1 1 0 110 2zM19.535 6.121L16.99 8.667a6.034 6.034 0 00-1.374-1.455l2.505-2.505a1 1 0 111.414 1.414zM12 16a4 4 0 100-8 4 4 0 000 8z' />
  </svg>
)

export default SvgSunFilled
